<template>
    <div class="mainList">
        <div class="mainListHead">
            <div class="HeadTab">
                <el-tabs type="card" v-model="tabVal" @tab-click="handleClick">
                <el-tab-pane v-for="(todo,index) in tabArray" :key="todo.name+'_'+index" :name="''+todo.type"><span slot="label"><span>{{todo.name}}</span><b v-show="todo.flag == true && todo.warnNum != 0">{{todo.warnNum}}</b></span></el-tab-pane>
                </el-tabs>
            </div>
            <div class="HeadSearch">
                <div>            
                  <div class="searchBtn special" @mousemove="mousearch">
                      <i></i>
                      <el-input 
                      placeholder="搜索监测点名称、编号、地址" 
                      v-model="searchInput" 
                      clearable 
                      @clear="clearableBack" 
                      ref="inputRef" 
                      @blur="searchBlur"></el-input>
                  </div>
                </div>
                <div class="screenBtn">
                    <a @click="screenClick">筛选</a>
                    <div class="screenTip" v-show="screenBtnShow">
                        <div class="screenHead">
                        <div class="headTxt">筛选</div>
                        <div class="headIcon" @click.stop="headIcon"></div>
                    </div>
                    <div class="screenMain">
                        <el-form :model="ruleFormOption" ref="ruleFormOption" class="demo-ruleForm3">
                            <el-form-item prop="deviceStatusVal"> 
                                <div class="formHead">{{deviceStatus.title}}</div>
                                <div class="formMain">
                                    <el-checkbox-group v-model="ruleFormOption.deviceStatusVal">
                                        <el-checkbox-button v-for="(item,index) in deviceStatus.option" :key="index" :label="item.value">{{item.name}}</el-checkbox-button>
                                    </el-checkbox-group>
                                </div>
                            </el-form-item>
                            <el-form-item prop="communicationStateVal"> 
                                <div class="formHead">{{communicationState.title}}</div>
                                <div class="formMain">
                                    <el-checkbox-group v-model="ruleFormOption.communicationStateVal">
                                        <el-checkbox-button v-for="(item,index) in communicationState.option" :key="index" :label="item.value">{{item.name}}</el-checkbox-button>
                                    </el-checkbox-group>
                                </div>
                            </el-form-item>
                            <el-form-item prop="monitorStateVal"> 
                                <div class="formHead">{{monitorState.title}}</div>
                                <div class="formMain">
                                    <el-checkbox-group v-model="ruleFormOption.monitorStateVal">
                                        <el-checkbox-button v-for="(item,index) in monitorState.option" :key="index" :label="item.value">{{item.name}}</el-checkbox-button>
                                    </el-checkbox-group>
                                </div>
                            </el-form-item>
                            <el-form-item prop="pointStateVal"> 
                                <div class="formHead">{{pointState.title}}</div>
                                <div class="formMain">
                                    <el-checkbox-group v-model="ruleFormOption.pointStateVal">
                                        <el-checkbox-button v-for="(item,index) in pointState.option" :key="index" :label="item.value">{{item.name}}</el-checkbox-button>
                                    </el-checkbox-group>
                                </div>
                            </el-form-item>
                            <el-form-item class="screenMainBtn">
                                <el-button @click="resetruleFormOption('ruleFormOption')">重置</el-button>
                                <el-button type="primary" @click="submitruleFormOption('ruleFormOption')">确定</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <div class="mainListContain clearfix">
            <div v-show="detailsArray.length > 0" class="boxContain">
              <div class="boxItem" :class="{disabled:item.enabled}" v-for="(item,index) in detailsArray" :key="index" :style="{width: widthCard + 'px'}" @click="boxItemClick(item.id,item.type)">
                <div class="boxIcon">
                  <div class="boxIconImg">
                    <img v-if="item.type == 1" src="../assets/img/typeIcon1.png" alt="icon">
                    <img v-else-if="item.type == 2" src="../assets/img/typeIcon2.png" alt="icon">
                    <img v-else-if="item.type == 3" src="../assets/img/typeIcon3.png" alt="icon">
                    <img v-else-if="item.type == 4" src="../assets/img/typeIcon4.png" alt="icon">
                    <img v-else-if="item.type == 5" src="../assets/img/typeIcon5.png" alt="icon">
                    <img v-else-if="item.type == 6" src="../assets/img/typeIcon6.png" alt="icon">
                    <img v-else-if="item.type == 7" src="../assets/img/typeIcon7.png" alt="icon">
                    <img v-else-if="item.type == 8" src="../assets/img/typeIcon8.png" alt="icon">
                  </div>
                  <div class="boxIconDisable" v-show="item.enabled">
                    <img src="../assets/img/prohibit.png" alt="icon">
                  </div>
                  <span class="tipsNum" v-show="item.warnNum != 0">
                    <span v-if="item.warnNum>99">99+</span>
                    <span v-else>{{item.warnNum}}</span>
                  </span>
                </div>
                <div class="boxText" :style="{width: widthText + 'px'}">
                  <div>
                      <el-tooltip class="item" effect="dark" :content="item.monitoringName" :disabled="widthText > overflowText" placement="bottom-start">
                          <span @mouseover="changeText($event)">{{item.monitoringName}}</span>
                      </el-tooltip>
                  </div>
                  <div>
                      <el-tooltip class="item" effect="dark" :content="item.detailAddress" :disabled="widthText > overflowText" placement="bottom-start">
                          <span @mouseover="changeText($event)">{{item.detailAddress}}</span>
                      </el-tooltip>
                    </div>
                  <div>
                    <span class="Online" v-if="item.deviceStatus == 0">启用</span>
                    <span class="fault" v-else>故障</span>
                    <span class="Online" v-if="item.connectStatus == false">在线</span>
                    <span class="Offline" v-else>离线</span>
                    <span class="Online" v-if="item.runStatus == 0">正常</span>
                    <span class="alarm" v-else-if="item.runStatus == 1">告警</span>
                    <span class="early" v-else>预警</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="detailsArray!='false' && detailsArray.length == 0" class="No">
              <img src="../../static/img/Nodata.png">
              <span>{{msgRouter}}</span>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['pageActive','tabArray','detailsArray','routerWarnManger'],
        data() {
            return {
              overflowText:'', //文字的宽度
              widthNum:'',
                widthCard: '', //计算卡片宽度
                widthText: '', //计算卡片文本宽度
                msg: '监控点管理-列表组件',
                searchInput:'',
                tabVal:'',
                deviceStatus:{//设备状态
                title:'设备状态',
                    option:[{
                        name:'启用',
                        value:'0'
                    },{
                        name:'故障',
                        value:'1'
                    }]
                }, 
                monitorState:{ //监测状态
                title:'监测状态',
                    option:[{
                        name:'正常',
                        value:'0'
                    },{
                        name:'告警',
                        value:'1'
                    },{
                        name:'预警',
                        value:'2'
                    }]
                },
                communicationState:{ //通讯状态
                title:'通讯状态',
                    option:[{
                        name:'在线',
                        value:'0'
                    },{
                        name:'离线',
                        value:'1'
                    }]
                },
                pointState:{ //监测点状态
                    title:'启用状态',
                    option:[{
                        name:'启用',
                        value:'0'
                    },{
                        name:'禁用',
                        value:'1'
                    }]
                },
                ruleFormOption:{ //筛选多选值
                  deviceStatusVal:[],
                  monitorStateVal:[],
                  communicationStateVal:[],
                  pointStateVal:[]
                },
                screenBtnShow:false,
                ISdisabled:false,
                target:'',
                msgRouter:'暂无数据！',
            }
        },
        created() {
          if(this.$route.path==='/content/warningManger'){
            this.msgRouter='当前暂无告警设备！';
          }else if(this.$route.path==='/content/indexExamine'){
            this.msgRouter='当前暂无审核设备！';
          }
            if(sessionStorage.getItem('ruleFormOption') && sessionStorage.getItem('returnType') == '1'){
              this.$nextTick(function(){
                this.ruleFormOption = JSON.parse(sessionStorage.getItem('ruleFormOption'));
              })
            }
            if(sessionStorage.getItem('tabValue')&& sessionStorage.getItem('returnType') == '1'){
              this.tabVal=sessionStorage.getItem('tabValue');
              this.$emit('listenType',[this.tabVal]);//传值
            }
            var lett = this;
            document.onkeydown = function(e) {
                var key = window.event.keyCode;
                if (key == 13) {
                lett.searchBlur();
                }
            }
        },
        updated() {
            this.initFont();
        },
        mounted() {
            let that = this;
            function initFont() {
                that.widthNum = $('.boxContain').outerWidth(true);
                let w = (that.widthNum) / 440;
                let w1 = parseInt(w);
                that.widthCard = Math.floor((that.widthNum / (w1 + 1)) -8)
                that.widthText = that.widthCard - 130;
            }initFont();
            $(window).resize(initFont);
        },
        computed:{
          getMap() {
              this.screenBtnShow = false
            return this.$store.state.buildingId
          },
          leftoggle() {
            return this.$store.state.leftoggle
          }
        },
        watch: {
         getMap (newV, oldV) { // status的变化，然后执行操作
              this.ruleFormOption.deviceStatusVal = []
              this.ruleFormOption.monitorStateVal = []
              this.ruleFormOption.communicationStateVal = []
              this.ruleFormOption.pointStateVal = [];
              this.tabVal='0';
              this.$emit('listenType','0');//传值
              this.$emit('listenSeav',this.ruleFormOption);//传值
          },
          leftoggle (newV, oldV) { // status的变化，然后执行操作
            this.initFont();
          }
        },
        methods: {
           changeText(e){ //文字显示...
                let ev = e || window.event;
                this.overflowText = $(ev.srcElement).outerWidth(true)
           },
            initFont(){
                let that = this;
                that.widthNum = $('.boxContain').outerWidth(true);
                let w = (that.widthNum) / 440;
                let w1 = parseInt(w);
                that.widthCard = Math.floor((that.widthNum / (w1 + 1)) -8)
                that.widthText = that.widthCard - 130;
            },
            handleClick(tab, event){ //Tab切换
              this.$emit('listenType',[this.tabVal]);//传值
            },
            mousearch(event){
                if(event.target.className == "el-input__icon el-icon-circle-close el-input__clear"){
                    this.target = 1;
                }else{
                    this.target = 0
                }
            },
            searchBlur(){ //失去焦点搜索
                if(this.target == 1){
                 this.searchInput = '';
                 this.$refs.inputRef.$el.children[0].focus();
                 this.target = 0
                }else{
                    this.$emit('listenSearch',this.searchInput); //传值
                }
            },
            screenClick(){ //筛选按钮
                this.screenBtnShow = true;//显示弹层
            },
            headIcon(){//关闭弹层按钮
                this.screenBtnShow = false;//隐藏弹层
            },
            submitruleFormOption(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$emit('listenSeav',this.ruleFormOption);//传值
                        this.screenBtnShow = false;
                    } else {
                        return false;
                    }
                });
            },
            resetruleFormOption(formName) {
                this.$refs[formName].resetFields();
                this.$emit('listenSeav',this.ruleFormOption);//传值
            },
            boxItemClick(id,type){ //进入详情
              sessionStorage.setItem('saveId',id); //详情id
              sessionStorage.setItem('ruleFormOption',JSON.stringify(this.ruleFormOption));
              sessionStorage.setItem('tabValue',this.tabVal);
              sessionStorage.setItem('returnType',0) //区分是否保留筛选条件历史记录
                if(this.pageActive == 1) {
                    // 进入监控详情页面
                    if(this.isAuth('common:interface')){
                        this.$router.push({path:'/content/monitorDetails'})
                    }
                } else if(this.pageActive == '4-1') {
                    this.$router.push({path:'/content/addMonitor',query:{IStrue:'true'}}); //进入非监测点详情页
                } else if(this.routerWarnManger==='warnDetail'){
                  this.$router.push({path:'/content/warnDetail',query:{type:type}}); //进入告警详情
                } else if(this.routerWarnManger==='warnExamine'){
                  this.$router.push({path:'/content/warnExamine',query:{type:type}}); //进入审核详情
                } else if(this.routerWarnManger==='searchWarnDetail'){
                  this.$router.push({path:'/content/searchWarnDetail',query:{type:type}}); //进入综合查询详情
                }
            },
            clearableBack(){ //清除回调
               this.$refs.inputRef.$el.children[0].focus();
            },
            //监控详情跳转
            monitorDetails() {
                this.$router.push({path:'/content/monitorDetails'})
            },
        }
    }
</script>

<style scoped lang="scss">
@import "@/assets/css/mixin.scss";
.Monitor .HeadTab{
    width: 44% !important;
}

.el-main .mainList{
    margin-right: 1.05%;
    background-color: #fff;
    position: relative;
    .mainListHead{
        width: 100%;
        height: 41px;
        @include flexible;
        @include alignItems(center);
        @include justify(space-between);
        background-color: #fafafa;
        border-bottom: 1px solid #f0f0f0;
        .HeadTab{
            width: 58%;
            & b{
                margin-left: 8px;
                display: inline-block;
                padding: 2px 4.5px;
                font-size: 12px;
                @include borderRadius(16px);
                line-height: 1;
                font-weight: normal;
                font-style: normal;
                background-color: #ec1c00;
                color: #fff;
            }
        }
        .HeadSearch{
            @include flexible;
            @include alignItems(center);
            @include justify(space-between);
            .searchBtn {
                position: relative;
                i {
                    position: absolute;
                    top: 7px;
                    left: 10px;
                    @include wh(16px,16px);
                    @include bgImg('../assets/img/search2.png');
                    z-index: 1;
                }
            }
            .screenBtn{
                position: relative;
                .screenTip{
                    position: absolute;
                    right: 10px;
                    top: 24px;
                    z-index: 1000;
                    width: 340px;
                    // min-height: 345px;
                    min-height: 395px;
                    border: 1px solid #d1e8ff;
                    -webkit-box-shadow: 0 0 4px #198cff;
                    -moz-box-shadow: 0 0 4px #198cff;
                    box-shadow: 0 0 4px #198cff;
                    background-color: #fff;
                    .screenHead {
                        .headTxt {
                            margin:20px 0;
                            margin-left: 20px;
                            font-size: $fontSizeFive;
                            line-height: $fontSizeFive;
                            color: $TxteAllcolor;
                            font-weight: bold;
                        }
                        .headIcon{
                            position: absolute;
                            right: 0;
                            top: 0;
                            display: inline-block;
                            width: 42px;
                            height: 42px;
                            cursor: pointer;
                            @include bgImg('../assets/img/close.png');
                            &:hover{
                                @include bgImg('../assets/img/closeClick.png');
                            }
                        }
                    }
                }
            }
        }
    }
    .screenMain{
        padding: 0 20px;
        & .el-form{
            min-height: 241px;
            position: relative;
            .formHead{
              font-size: $fontSizeTwo;
              line-height: $fontSizeTwo;
              margin-bottom: 10px;
              color: #999999;
            }
            .screenMainBtn{
              position: absolute;
              right: 0;
            //   bottom: -50px;
              bottom: -90px;
            }
        }
    }
    .mainListContain{
        padding: 10px 2px 10px 10px;
        background-color: #fff;
        .boxContain{
            .boxItem{
                float: left;
                margin-right: 8px;
                margin-bottom: 8px;
                padding: 20px;
                min-width: 285px;
                max-width: 432px;
                @include flexible;
                @include alignItems(center);
                outline: 1px solid #e0e0e0;
                box-sizing: border-box;
                @include textOverflow;
                cursor: pointer;
                color: #282828;
                &.disabled{
                    color: #666666 !important;
                    & .Online,.Offline,.fault,.alarm{
                        border: 1px solid #8e8e8e !important;
                        background-color: #f5f5f5 !important;
                    }
                }
                &:hover{
                  outline: 1px solid rgba(25,140,255,.3);
                  -webkit-box-shadow: 0 2px 12px 0 rgba(25,140,255,.3);
                  -moz-box-shadow: 0 2px 12px 0 rgba(25,140,255,.3);
                  box-shadow: 0 2px 12px 0 rgba(25,140,255,.3);
                }
                &:active{
                  outline: 1px solid #e0e0e0;
                  -webkit-box-shadow: none;
                  -moz-box-shadow: none;
                  box-shadow: none;
                  background-color: #fafcff;
                }
                .boxIcon{
                    position: relative;
                    &>.boxIconImg{
                        width: 80px;
                        height: 80px;
                        img{
                            width: 100%;
                            height: 100%;
                            vertical-align: middle;
                        }
                    }
                    &>.boxIconDisable{
                        width: 28px;
                        height: 28px;
                        position: absolute;
                        right: 1px;
                        bottom: -3px;
                        img{
                          width: 100%;
                          height: 100%;
                          vertical-align: middle;
                        }
                    }
                    .tipsNum{
                        display: inline-block;
                        position: absolute;
                        right: 0px;
                        top: 0px;
                        padding: 0 6.5px;
                        height: 20px;
                        line-height: 20px;
                        font-size: 12px;
                        @include borderRadius(16px);
                        font-weight: normal;
                        font-style: normal;
                        background-color: #ec1c00;
                        color: #fff;
                    }
                }
                .boxText{
                    margin-left: 10px;
                    &>div{
                        @include textOverflow;
                        margin-bottom: 13px;
                        font-size: $fontSizeOne;
                    }
                    &>div:nth-child(1){
                        font-size: $fontSizeThree;
                        line-height: 16px;
                        margin-bottom: 10px;
                    }
                    &>div:nth-child(3){
                        margin-bottom: 0;
                        &>span{
                            display: inline-block;
                            width: 45px;
                            text-align: center;
                            line-height: 20px;
                            @include borderRadius(22px);
                            box-sizing: border-box;
                            margin-right: 8px;
                            &.Online{
                                border: 1px solid #48ff48;
                                background-color: #daffda;
                            }
                            &.Offline{
                                border: 1px solid #8e8e8e;
                                background-color: #f5f5f5;
                            }
                            &.fault{
                                border: 1px solid #fb8c00;
                                background-color: #faefe1;
                            }
                            &.alarm{
                                border: 1px solid #f55353;
                                background-color: #f5dcdc;
                            }
                            &.early{
                                border: 1px solid #FF7F00;
                                background-color: #FFEC8B;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>





// WEBPACK FOOTER //
// src/components/todoList.vue